<div class="form-holder">
    <div class="form-content form-visible">
        <!-- note that mappedPreferences structure is as preferences in separate row -->
        <ng-container *ngFor="let preferenceArray of mappedPreferences">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 preference" *ngFor="let preference of preferenceArray">
                    <span class="toggle-label">{{ preference.label }}</span>
                    <serviceos-ng-slide-toggle 
                        [name]="preference.key"
                        [checked]="!!preference.value"
                    ></serviceos-ng-slide-toggle>
                </div>
            </div>
        </ng-container>
    </div>
    <serviceos-ng-local-loader [showLoader]="showLoader"></serviceos-ng-local-loader>
</div>